import { render, staticRenderFns } from "./PermissionsComp.vue?vue&type=template&id=0ef41f4e&scoped=true&"
import script from "./PermissionsComp.vue?vue&type=script&lang=js&"
export * from "./PermissionsComp.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsComp.vue?vue&type=style&index=0&id=0ef41f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef41f4e",
  null
  
)

export default component.exports